export const CBADGE_COLORS = Object.freeze({
	SUCCESS: 'success',
	SECONDARY: 'secondary',
	WARNING: 'warning',
	DANGER: 'danger',
	PRIMARY: 'primary',
});
